import PlainLayout from '@/layouts/PlainLayout';
import {ProgramClassScheduleDetails} from '@/pages/Programs/ProgramClassScheduleDetails';
import {ProgramClassSchedulesList} from '@/pages/Programs/ProgramClassSchedulesList';
import {ProgramsRoot} from '@/pages/Programs/ProgramsRoot';
import {Navigate, RouteObject} from 'react-router-dom';
import PlayerLayout from './layouts/PlayerLayout';
import RootAdminLayout from './layouts/RootAdminLayout';
import RootAuthenticatedLayout from './layouts/RootAuthenticatedLayout';
import RootLayout from './layouts/RootLayout';
import RootTrainerLayout from './layouts/RootTrainerLayout';
import Admin from './pages/Admin/Admin';
import AdminAnalyzeUser from './pages/Admin/AdminAnalyzeUser';
import {BookingConfirmation} from './pages/Booking/Confirmation/BookingConfirmation';
import {MyBookings} from './pages/Booking/MySessions/MyBookings';
import {BookingReview} from './pages/Booking/Review/BookingReview';
import {BookingSessionList} from './pages/Booking/SessionList/BookingSessionList';
import {FkoConfirmationPage} from './pages/Fko/FkoConfirmationPage/FkoConfirmationPage';
import {FkoHelpForm} from './pages/Fko/FkoHelpForm/FkoHelpForm';
import {FkoRestart} from './pages/Fko/FkoRestart/FkoRestart';
import {ForgetPassword} from './pages/ForgetPassword/ForgetPassword';
import {Help} from './pages/Help/Help';
import {Helpdesk} from './pages/Helpdesk/Helpdesk';
import {LeaderboardDetailsData} from './pages/Leaderboards/LeaderboardDetails/LeaderboardDetailsData';
import {LeaderboardList} from './pages/Leaderboards/LeaderboardList/LeaderboardList';
import {Logout} from './pages/Logout/Logout';
import {Profile} from './pages/Profile/Profile';
import {RegistrationLanding} from './pages/RegistrationLanding/RegistrationLanding';
import {PlayersRoot} from './pages/RegistrationPlayers/PlayersRoot';
import {RegistrationScheduling} from './pages/RegistrationScheduling/RegistrationScheduling';
import {SignInSignUp} from './pages/SignInSignUp/SignInSignUp';
import {SignUp} from './pages/SignUp/SignUp';
import {TrainerHomePage} from './pages/Trainer/Trainer';
import {TrainerDirectEmulation} from './pages/Trainer/TrainerDirectEmulation';
import {TrainerRewritePath} from './pages/Trainer/TrainerRewritePath';
import {VerifyEmail} from './pages/VerifyEmail/VerifyEmail';
// import {ProgramEnrollmentsList} from '@/pages/Programs/ProgramEnrollmentsList';
// import {ProgramEnrollmentDetails} from '@/pages/Programs/ProgramEnrollmentDetails';
import {DbatSportWrapper} from '@/components/FKO/DbatSportWrapper';
import {FTCSportWrapper} from '@/components/FKO/FTCSportWrapper';
import {TocaSportWrapper} from '@/components/FKO/TocaSportWrapper';
import {PlayerImpersonation} from '@/components/Impersonation/PlayerImpersonation';
import {roleType} from '@/constants/constants';
import ClassicLayout from '@/layouts/ClassicLayout';
import CoachDirectorLayout from '@/layouts/CoachDirectorLayout';
import CoachNavbarLayout from '@/layouts/CoachNavbarLayout';
import DirectorNavbarLayout from '@/layouts/DirectorNavbarLayout';
import {ExistingPlayerOnboardingLayout} from '@/layouts/ExistingPlayerOnboardingLayout';
import FKOLayout from '@/layouts/FKOLayout';
import LeaderBoardLayout from '@/layouts/LeaderBoardLayout';
import {OnboardingLayout} from '@/layouts/OnboardingLayout';
import TrainerNavbarLayout from '@/layouts/TrainerNavbarLayout';
import {AthleteCalendar} from '@/pages/AthleteCalendar/AthleteCalendar';
import AvatarCreator from '@/pages/AvatarCreator/AvatarCreator';
import {BaselineBenchmarks} from '@/pages/Baseline/Benchmarks/BaselineBenchmarks';
import {BaselineRetest} from '@/pages/Baseline/Retest/BaselineRetest';
import {BaselineSessionData} from '@/pages/Baseline/SessionData/BaselineSessionData';
import {BaselineSessionInfo} from '@/pages/Baseline/SessionInfo/BaselineSessionInfo';
import {CenterDiscovery} from '@/pages/CenterDiscovery/CenterDiscovery';
import {CoachEditTeam} from '@/pages/Coach/CoachEditTeam/CoachEditTeam';
import {CoachHome} from '@/pages/Coach/CoachHome';
import {CoachInvite} from '@/pages/Coach/CoachInvite/CoachInvite';
import {CoachPlayerAssessmentData} from '@/pages/Coach/CoachPlayerAssessmentData/CoachPlayerAssessmentData';
import {CoachTeam} from '@/pages/Coach/CoachTeam/Team';
import {CoachTeams} from '@/pages/Coach/CoachTeams/CoachTeams';
import {ConnectsBaselineData} from '@/pages/Connects/BaselineData';
import {Connects} from '@/pages/Connects/Connects';
import {ConnectsFinish} from '@/pages/Connects/ConnectsFinish';
import {NextWeek} from '@/pages/Connects/NextWeek';
import {Schedule} from '@/pages/Connects/Schedule';
import {CustomizeJersey} from '@/pages/CustomizeJersey/CustomizeJersey';
import Dbat75FreeSwingClaimRegistrationPage from '@/pages/Dbat75FreeSwings/Dbat75FreeSwingClaimRegistrationPage';
import {Coaches} from '@/pages/Director/Coaches/Coaches';
import {DirectorEditTeam} from '@/pages/Director/DirectorEditTeam/DirectorEditTeam';
import {DirectorHome} from '@/pages/Director/DirectorHome';
import {DirectorInvite} from '@/pages/Director/DirectorInvite/DirectorInvite';
import {DirectorPlayerAssessmentData} from '@/pages/Director/DirectorPlayerAssessmentData/DirectorPlayerAssessmentData';
import {DirectorTeam} from '@/pages/Director/DirectorTeam/DirectorTeam';
import {DirectorTeams} from '@/pages/Director/DirectorTeams/DirectorTeams';
import {ExistingPlayerOnboarding} from '@/pages/ExistingPlayerOnboarding/ExistingPlayerOnboarding';
import {DbatFkoConfirmationPage} from '@/pages/Fko/DbatFkoConfirmationPage';
import FreeLeaguesRegistrationPage from '@/pages/FreeLeagues/FreeLeaguesRegistrationPage';
import FreePickupSoccerRegistrationPage from '@/pages/FreePickupSoccer/FreePickupSoccerRegistrationPage';
import FtcDsrRegistrationPage from '@/pages/FtcDsr/FtcDsrRegistrationPage';
import {MlsAuthCreateProfile} from '@/pages/MLSAuth/MlsAuthCreateProfile';
import {MLSAuthEmailSignIn} from '@/pages/MLSAuth/MLSAuthEmailSignIn';
import {MlsAuthLanding} from '@/pages/MLSAuth/MlsAuthLanding';
import {MLSAuthPhoneSignIn} from '@/pages/MLSAuth/MLSAuthPhoneSignIn';
import {MLSAuthSignin} from '@/pages/MLSAuth/MLSAuthSignin';
import {MLSAuthSignup} from '@/pages/MLSAuth/MLSAuthSignup';
import {Profiles} from '@/pages/MLSAuth/Profiles';
import {MyScore} from '@/pages/MyScore/MyScore';
import {MySessions} from '@/pages/MySessions/MySessions';
import {NewUserOnboarding} from '@/pages/NewUserOnboarding/NewUserOnboarding';
import {NextSession} from '@/pages/NextSession/NextSession';
import {PlayerHome} from '@/pages/PlayerHome/PlayerHome';
import {ProgramCheckout} from '@/pages/Programs/ProgramCheckout';
import {ProgramsPromotionalLanding} from '@/pages/Programs/ProgramsPromotionalLanding';
import {PhoneSignIn} from '@/pages/SignInSignUp/PhoneNumberAddVerification/PhoneSignIn';
import {TeamOnboarding} from '@/pages/TeamOnboarding/TeamOnboarding';
import PlayerContactDetails from '@/pages/TocaProgramsLanding/PlayerContactDetails/PlayerContactDetails';
import TocaProgramsLanding from '@/pages/TocaProgramsLanding/TocaProgramsLanding';
import {PlayerAssessmentSportWrapper} from './components/FKO/PlayerAssessmentSportWrapper';
export const routes: RouteObject[] = [
  // Direct trainer route as currently used by the native trainer app
  {
    path: '/player/:mboClientId/:siteId/overall',
    element: <TrainerRewritePath />,
  },
  {
    path: '/_internal/_impersonate',
    element: <PlayerImpersonation />,
  },
  {
    element: <RootLayout />,
    children: [
      // Authenticated but not authorized, so won't pass check in AuthContainer
      {
        path: 'verify-email',
        element: <VerifyEmail />,
      },
      {
        path: '/auth',
        children: [
          {
            index: true,
            element: <MlsAuthLanding />,
          },
          {
            path: 'signup',
            element: <MLSAuthSignup />,
          },
          {
            path: 'signin',
            children: [
              {
                index: true,
                element: <MLSAuthSignin />,
              },
              {
                path: 'phone',
                element: <MLSAuthPhoneSignIn />,
              },
              {
                path: 'email',
                element: <MLSAuthEmailSignIn />,
              },
            ],
          },
          {
            path: 'forget-password',
            element: <ForgetPassword />,
          },
        ],
      },
      // PUBLIC ROUTES
      {
        element: <ClassicLayout />,
        children: [
          {
            path: '/old-auth',
            children: [
              {
                index: true,
                element: <SignInSignUp />,
              },
              {
                path: 'signin/phone',
                element: <PhoneSignIn />,
              },
            ],
          },
          {
            path: '/signup',
            element: <SignUp />,
          },
          {
            path: '/helpdesk',
            element: <Helpdesk />,
          },
          //   {
          // Referral page is not used anymore
          //     path: '/referral',
          //     element: <TocaProgramsLanding source={TocaProgramsLandingSource.REFERRAL} />,
          //   },
          {
            path: '/toca-programs',
            children: [
              {
                index: true,
                element: <TocaProgramsLanding />,
              },
              {
                path: 'player-contact-details',
                element: <PlayerContactDetails />,
              },
            ],
          },
          // {
          //   path: '/leaderboards/:id',
          //   element: <LeaderboardDetailsData />,
          // },
        ], // END CLASSIC_LAYOUT
      },
      {
        element: <OnboardingLayout />,
        path: '/onboarding',
        children: [
          {
            index: true,
            element: <NewUserOnboarding />,
          },
        ],
      },
      {
        element: <ExistingPlayerOnboardingLayout />,
        path: '/player-onboarding',
        children: [
          {
            index: true,
            element: <ExistingPlayerOnboarding />,
          },
        ],
      },
      {
        element: <OnboardingLayout />,
        path: '/team-onboarding',
        children: [
          {
            index: true,
            element: <TeamOnboarding />,
          },
        ],
      },
      {
        element: <PlainLayout />,
        children: [
          // NOTE: We use parent routes without `element` (which will make them use <Outlet/> as default element) and then
          //       define a child index route so that we can associate breadcrumb info. If we don't use parent routes
          //       without `element`, then each parent's element component would need to define <Outlet /> themselves.
          {
            path: 'offer',
            children: [
              {
                path: 'dbat-75-free-swings-claim',
                element: <Dbat75FreeSwingClaimRegistrationPage />,
              },
            ],
          },
          {
            path: '/ftc-dsr',
            children: [
              {
                index: true,
                element: <FtcDsrRegistrationPage />,
              },
            ],
          },
          {
            path: '/ftp',
            element: <FreePickupSoccerRegistrationPage />,
          },
          {
            path: '/ftl',
            element: <FreeLeaguesRegistrationPage />,
          },
          {
            path: '/:sessionId?/ftc',
            element: <FTCSportWrapper />,
            // handle: {
            //   crumb: () => ({name: 'Free Training Classes'}),
            // },
            children: [
              {
                index: true,
                element: <ProgramsPromotionalLanding />,
              },
              {
                path: 'help',
                element: <FkoHelpForm />,
              },
              {
                path: ':siteId',
                // handle: {
                //   crumb: (data: any) => ({name: data?.currentLocation?.name}),
                // },
                children: [
                  {
                    index: true,
                    element: <ProgramsRoot />,
                  },
                  {
                    path: ':programId',
                    handle: {
                      crumb: (data: any) => ({name: data?.program?.name}),
                    },
                    children: [
                      {
                        index: true,
                        element: <ProgramClassSchedulesList />,
                      },
                      {
                        path: ':enrollmentId/:classId?', // TODO CLASSES eventually rename
                        handle: {
                          crumb: (data: any) => ({name: data?.enrollment?.name}),
                        },
                        children: [
                          {
                            index: true,
                            element: <ProgramClassScheduleDetails />,
                          },
                          {
                            path: 'register',
                            handle: {
                              crumb: () => ({name: 'Book Now'}),
                            },
                            element: <ProgramCheckout />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: '/programs',
            handle: {
              crumb: () => ({name: 'Programs'}),
            },
            children: [
              {
                index: true,
                element: <ProgramsRoot />,
              },
              {
                path: ':siteId',
                handle: {
                  crumb: (data: any) => ({name: data?.currentLocation?.name}),
                },
                children: [
                  {
                    index: true,
                    element: <ProgramsRoot />,
                  },
                  {
                    path: ':programId',
                    handle: {
                      crumb: (data: any) => ({name: data?.program?.name}),
                    },
                    children: [
                      // {
                      //   index: true,
                      //   element: <ProgramEnrollmentsList />,
                      // },
                      {
                        index: true,
                        element: <ProgramClassSchedulesList />,
                      },
                      {
                        path: ':enrollmentId/:classId',
                        handle: {
                          crumb: (data: any) => ({name: data?.enrollment?.name}),
                        },
                        // element: <ProgramEnrollmentDetails />,
                        children: [
                          {
                            index: true,
                            element: <ProgramClassScheduleDetails />,
                          },
                          {
                            path: 'register',
                            handle: {
                              crumb: () => ({name: 'Book Now'}),
                            },
                            // element: <RootAuthenticatedLayout />,
                            element: <ProgramCheckout />,
                            // children: [
                            //   {
                            //     index: true,
                            //     element: <ProgramCheckout />,
                            //   },
                            // ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: '/baseline-session-info',
            element: <BaselineSessionInfo />,
          },
          {
            path: '/baseline-benchmarks',
            element: <BaselineBenchmarks />,
          },
          {
            path: '/baseline-retest',
            element: <BaselineRetest />,
          },
          // {
          //   path: '/leaderboards/:id',
          //   element: <LeaderboardDetailsData />,
          // },
        ], // END PLAIN_LAYOUT
      },
      {
        element: <LeaderBoardLayout />,
        children: [
          {
            path: '/leaderboards/:id',
            element: <LeaderboardDetailsData />,
          },
        ],
      },
      {
        // Center Discovery page that displays the nearest test centers based on the user's location.
        path: '/center-discovery',
        element: <CenterDiscovery />,
      },
      {
        path: '/logout',
        element: <Logout />,
      },
      {
        // Special TV variant that supports full screen layout
        path: '/tv/leaderboards/:id',
        element: <LeaderboardDetailsData />,
      },
      {
        element: <FKOLayout />,
        children: [
          {
            path: '/:sessionId?/fko/',
            element: <TocaSportWrapper />,
            children: [
              {
                index: true,
                element: <RegistrationLanding />,
              },
              {
                path: 'help',
                element: <FkoHelpForm />,
              },
              {
                path: 'restart',
                element: <FkoRestart />,
              },
              {
                children: [
                  {
                    path: 'players',
                    element: <PlayersRoot />,
                  },
                  {
                    path: 'schedule',
                    element: <RegistrationScheduling />,
                  },
                  {
                    path: 'confirmation',
                    element: <FkoConfirmationPage />,
                  },
                ],
              },
            ],
          },
          {
            path: '/dbat-fps',
            element: <Navigate to="/baseball-fps" />,
          },
          {
            path: '/:sessionId?/baseball-fps/',
            element: <DbatSportWrapper />,
            children: [
              {
                index: true,
                element: <RegistrationLanding />,
              },
              {
                path: 'help',
                element: <FkoHelpForm />,
              },
              {
                path: 'restart',
                element: <FkoRestart />,
              },
              {
                children: [
                  {
                    path: 'players',
                    element: <PlayersRoot />,
                  },
                  {
                    path: 'schedule',
                    element: <RegistrationScheduling />,
                  },
                  {
                    path: 'confirmation',
                    element: <DbatFkoConfirmationPage />,
                  },
                ],
              },
            ],
          },
          {
            path: '/:sessionId?/player-assessment/',
            element: <PlayerAssessmentSportWrapper />,
            children: [
              {
                index: true,
                element: <RegistrationLanding />,
              },
              {
                path: 'help',
                element: <FkoHelpForm />,
              },
              {
                path: 'restart',
                element: <FkoRestart />,
              },
              {
                children: [
                  {
                    path: 'players',
                    element: <PlayersRoot />,
                  },
                  {
                    path: 'schedule',
                    element: <RegistrationScheduling />,
                  },
                  {
                    path: 'confirmation',
                    element: <FkoConfirmationPage />,
                  },
                ],
              },
            ],
          },
        ],
      },

      // PROTECTED ROUTES
      {
        path: '/emulation?/:siteId?/',
        element: <RootAuthenticatedLayout />,
        children: [
          {
            path: 'create-profile',
            element: <MlsAuthCreateProfile />,
          },
          {
            path: 'profiles',
            element: <Profiles />,
          },
          {
            path: 'avatar-creator',
            element: <AvatarCreator />,
          },
          {
            path: 'customize-jersey',
            element: <CustomizeJersey />,
          },
          {
            element: <PlayerLayout />,
            children: [
              {
                index: true,
                element: <Navigate to="/home" />,
              },
              {
                path: 'home',
                element: <PlayerHome />,
              },
              {
                path: 'my-sessions',
                element: <MySessions />,
              },
              {
                path: 'my-score',
                element: <MyScore />,
              },
              {
                path: 'nextsession',
                element: <NextSession />,
              },
              {
                path: 'upcoming',
                element: <AthleteCalendar />,
              },
              {
                path: 'book-now',
                element: <Navigate to="/bookings" />,
              },
              {
                path: 'bookings',
                children: [
                  {
                    index: true,
                    element: <BookingSessionList />,
                  },
                  {
                    path: 'sessions/:initialDate',
                    element: <BookingSessionList reselect />,
                  },
                  {
                    path: 'review',
                    element: <BookingReview />,
                  },
                  {
                    path: 'confirmation',
                    element: <BookingConfirmation />,
                  },
                ],
              },
              {
                path: 'enrollments',
                children: [
                  {
                    path: 'register/:siteId/:programId/:enrollmentId/:classId?',
                    handle: {
                      // TODO Made this work for now but it would be better if we had this route nested with the
                      //      other routes that make up the breadcrumbs.
                      crumb: (data: any) => [
                        {name: 'Programs', path: '/programs'},
                        {name: data?.currentLocation?.name, path: `/programs/${data?.currentLocation?.siteId}`},
                        {
                          name: data?.program?.name,
                          path: `/programs/${data?.currentLocation?.siteId}/${data?.program?.id}`,
                        },
                        {
                          name: data?.enrollment?.name,
                          path: `/programs/${data?.currentLocation?.siteId}/${data?.program?.id}/${data?.enrollment?.id}`,
                        },
                        {name: 'Book Now'},
                      ],
                    },
                    element: <ProgramCheckout />,
                  },
                ],
              },
              {
                path: 'leaderboards',
                element: <LeaderboardList />,
              },
              {
                // Special TV variant that supports full screen layout
                path: 'tv/leaderboards',
                element: <LeaderboardList />,
              },
              {
                path: 'profile',
                element: <Profile />,
              },
              {
                path: 'mybookings',
                element: <MyBookings />,
              },
              {
                path: 'help',
                element: <Help />,
              },
              {
                path: 'baseline-session-data/:sessionId',
                element: <BaselineSessionData />,
              },
            ] /* END NavbarLayout **/,
          },
          // {
          //   path: 'baseline-session-data/:sessionDate',
          //   element: <PlainLayout />,
          //   children: [
          //     {
          //       index: true,
          //       element: <BaselineSessionData />,
          //     },
          //   ],
          // },
          {
            path: 'trainer',
            element: <RootTrainerLayout />,
            children: [
              {
                // element: <ClassicLayout />,
                element: <TrainerNavbarLayout />,
                children: [
                  {
                    index: true,
                    element: <TrainerHomePage />,
                  },
                  {
                    path: 'profile',
                    element: <TrainerDirectEmulation />,
                  },
                ],
              },

              {
                path: 'connects',
                element: <TrainerNavbarLayout />,
                children: [
                  {
                    path: '?trainer=:trainerID?',
                    element: <Connects />,
                  },
                  {
                    path: 'baseline/?trainer=:trainerID?',
                    element: <ConnectsBaselineData />,
                  },
                  {
                    path: 'nextWeek/?trainer=:trainerID?',
                    element: <NextWeek />,
                  },
                  {
                    path: 'schedule/?trainer=:trainerID?',
                    element: <Schedule />,
                  },
                  {
                    path: 'finish/?trainer=:trainerID?',
                    element: <ConnectsFinish />,
                  },
                  {
                    path: 'baseline-session-data/:sessionId',
                    element: <BaselineSessionData isTrainer={true} />,
                  },
                  {
                    path: 'sessions',
                    element: <MySessions isTrainer={true} />,
                  },
                  {
                    path: 'score',
                    element: <MyScore isTrainer={true} />,
                  },
                ],
              },
            ],
          },
          {
            path: 'admin',
            element: <RootAdminLayout />,
            children: [
              {
                index: true,
                element: <Admin />,
              },
              {
                path: 'analyze-user',
                element: <AdminAnalyzeUser />,
              },
            ],
          },
          {
            path: 'coach',
            element: <CoachDirectorLayout role={roleType.teamCoach} />,
            children: [
              {
                index: true,
                element: <CoachTeams />,
              },
              {
                element: <CoachNavbarLayout />,
                children: [
                  {
                    path: 'teams/:teamId',
                    children: [
                      {
                        index: true,
                        element: <CoachHome />,
                      },
                      {
                        path: 'players',
                        element: <CoachTeam />,
                      },
                      {
                        path: 'edit',
                        element: <CoachEditTeam />,
                      },
                      {
                        path: 'invite',
                        element: <CoachInvite />,
                      },
                      {
                        path: 'playerAssessmentData',
                        element: <CoachPlayerAssessmentData />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'director',
            element: <CoachDirectorLayout role={roleType.director} />,
            children: [
              {
                index: true,
                element: <DirectorTeams />,
              },
              {
                element: <DirectorNavbarLayout />,
                children: [
                  {
                    path: 'teams/:teamId',
                    children: [
                      {
                        index: true,
                        element: <DirectorHome />,
                      },
                      {
                        path: 'players',
                        element: <DirectorTeam />,
                      },
                      {
                        path: 'edit',
                        element: <DirectorEditTeam />,
                      },
                      {
                        path: 'invite',
                        element: <DirectorInvite />,
                      },
                      {
                        path: 'playerAssessmentData',
                        element: <DirectorPlayerAssessmentData />,
                      },
                      {
                        path: 'coaches',
                        element: <Coaches />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
